/**
 * Calendar view mode enum.
 */
export enum CalendarViewMode {
	Day = "day",
	Week = "week",
	Month = "month",
	Year = "year"
}
